const state = {
    welcomeLinks: [
        {
            class: 'link-facebook icon-facebook',
            url: 'https://facebook.com',
            title: 'Facebook'
        },
        {
            class: 'link-red icon-google-plus',
            url: 'https://google.com',
            title: 'Google'
        },
        {
            class: 'link-blue icon-twitter',
            url: 'https://twitter.com/',
            title: 'Twitter'
        },
        {
            class: 'link-red icon-youtube-play',
            url: 'https://youtube.com',
            title: 'Youtube'
        }
    ]
};

export default {
    namespaced: true,
    state
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/links.js